// Import api models.
import {
	AddressLocationAsMailingAddress,
	PerilDeductible
} from '@app/models/api';

interface NewBusinessApplicationPreliminaryState {
	propertyAddress?: AddressLocationAsMailingAddress;
	perilsDeductibles: PerilDeductible[];
};


const getInitialState = (): NewBusinessApplicationPreliminaryState => {
	return {
		propertyAddress: undefined,
		perilsDeductibles: [],
	};
};

export { getInitialState, NewBusinessApplicationPreliminaryState };